import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Div = styled.div`
  width: 100%;
  margin: auto;
  display: flex;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  align-self: stretch;
  align-items: center;
  flex-direction: column;
`;

function Main({ children }) {
  return <Div> {children} </Div>;
}

Main.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default Main;
